import { render, staticRenderFns } from "./InfoPanel.vue?vue&type=template&id=2fad68e2&scoped=true"
import script from "./InfoPanel.vue?vue&type=script&lang=ts"
export * from "./InfoPanel.vue?vue&type=script&lang=ts"
import style0 from "./InfoPanel.vue?vue&type=style&index=0&id=2fad68e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad68e2",
  null
  
)

export default component.exports